<template>
  <div class="family-showcase-container">
    <div class="title">
      {{ this.listingTitle }}
    </div>
    <div class="family-showcase">
      <div
          class="command-container prev-command-container"
          :style="isBeginning ? `opacity: 0.3` : 'opacity: 1'"
          v-if="windowWidth || this.$mq !== 'large' || valid_images.length > 4"
          :class="{ 'command-container--width-zero': this.isMobile && !windowWidth }"
          :tabindex="isBeginning ? null : '0'"
          @click="swiperInstance.slidePrev()"
          @keyup.enter="swiperInstance.slidePrev()"
      >
        <i
            aria-hidden="true"
            class="icon-arrow icon-arrow-sx"
            v-if="(!isBeginning && windowWidth) || (!isBeginning && this.$mq === 'large')"
        ></i>
        <div v-if="(!isBeginning && windowWidth && !isThemeVespa) || (!isBeginning && this.$mq === 'large' && !isThemeVespa)" class="separator"></div>
      </div>
      <!-- carousel -->
      <div ref="swiper" class="swiper">
        <!-- Additional required wrapper -->
        <div v-if="isThemeVespa && !isBeginning && this.valid_images.length > 4" class="swiper-gradient left" />
        <div v-if="isThemeVespa && !isEnd && this.valid_images.length > 4" class="swiper-gradient right" />
        <div class="swiper-wrapper" ref="wrapper">
          <!-- Slides -->
          <div
              class="swiper-slide"
              v-for="(item, index) in this.valid_images"
              :key="index"
              :style="`width: ${computedWidth}px;`"
              @click="navigateTo(item.href)"
              :class="{ 'swiper-slide-margin-left': computedFirstElementMobile(index) }"
          >
            <div :style="`width: ${computedWidth}px; height: ${computedHeight}px; user-selection: none;`">
              <img :src="item.img" alt="" style="object-fit: contain;" height="158" width="200" />
            </div>
            <div class="image-cover--label">{{ item.name }}</div>
          </div>
        </div>

        <!-- If we need pagination / don't delete it -->
        <div class="swiper-pagination"></div>
      </div>
      <div
          class="command-container next-command-container"
          :style="isEnd ? `opacity: 0.3` : 'opacity: 1'"
          v-if="windowWidth || this.$mq === 'large'"
          :class="{ 'command-container--width-zero': this.isMobile && !windowWidth }"
          :tabindex="isEnd ? null : '0'"
          @click="swiperInstance.slideNext()"
          @keyup.enter="swiperInstance.slideNext()"
      >
        <div v-if="(!isEnd && windowWidth && !isThemeVespa) || (!isEnd && this.$mq === 'large' && valid_images.length > 4 && !isThemeVespa)" class="separator"></div>
        <i
            aria-hidden="true"
            class="icon-arrow icon-arrow-dx"
            v-if="(!isEnd && windowWidth) || (!isEnd && this.$mq === 'large' && valid_images.length > 4)"
        ></i>
      </div>
    </div>
    <div class="fs-progress-bar--container" v-if="valid_images.length > 4">
      <div class="fs-progress-outer-bar">
        <div class="fs-progress-inner-bar" :style="`width: ${computedProgress}%;`"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper, { Pagination } from "swiper";
import router from '@wl-vue-utils/router.js'
import 'swiper/swiper.css';
import 'swiper/modules/navigation/navigation.scss';
import 'swiper/modules/pagination/pagination.scss';


export default {
  name: 'FamilyShowcase',
  router: router,
  components: {},
  data() {
    return {
      isOverlayOpen: false,
      swiperInstance: null,
      slideWidth: 0,
      slidesPerView: 2,
      parsed_images: [],
      valid_images: [],
      windowWidth: false
    }
  },
  props: {
    listingTitle: {
      type: String,
      required: false,
      default: ""
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    swiperSpace() {
      return this.isThemeVespa ? 5 : 20;
    },
    computedProgress() {
      if (!this.swiperInstance) {
        return 0;
      }
      const total = this.swiperInstance.pagination.bullets.length;
      const current = this.swiperInstance.realIndex;
      if (this.swiperInstance.isEnd) return 100;
      return (current+1) / total * 100;
    },
    computedHeight() {
      return this.$mq === 'small' ? 140 : 158;
    },
    computedWidth() {
      return this.$mq === 'small' ? 150 : 200;
    },
    computedFirstElementMobile() {
      return (index) => {
        return index === 0 && this.$mq === 'small'
      }
    },
    isEnd() {
      return this.swiperInstance?.isEnd ?? false;
    },
    isBeginning() {
      return this.swiperInstance?.isBeginning ?? false;
    },
    isMobile() {
      return this.$mq === 'small'
    },
    size() {
      const isMobile = this.$mq === "small"
      // handle breakpoint
      if (isMobile) {
        return this.mobileSize;
      } else {
        return this.desktopSize;
      }
    },
    isThemeVespa() {
      // Check if the body contains the class "theme-vespa"
      return document.body.classList.contains('theme-vespa');
    }
  },
  methods: {
    navigateTo(to = '') {
      this.$router.replace(to).then(() => {
        this.$router.go(0);
      });
    },
  },
  mounted() {
    // handle breakpoint
    const size = this.size;
    // calculate width
    const { width } = this.$refs.wrapper.getBoundingClientRect();
    this.slideWidth = size === "1" ? width / size : (width / size) - 33;
    // clean images to keep only ones with a valid url
    const validImages = []
    for(let i = 0; i < this.items.length; i++) {
      if(this.items[i] && this.items[i].img) {
        validImages.push(this.items[i])
      }
    }
    this.valid_images = [...validImages];
    const observer = new ResizeObserver(() => {
      // handle breakpoint
      const size = this.size;
      // calculate width
      const { width } = this.$refs.wrapper.getBoundingClientRect();
      const diff = this.$mq !== 'large' ? 43 : 33;
      this.slideWidth = size === "1" ? width / size : (width / size) - diff;
      // clean images to keep only ones with a valid url
      const validImages = []
      for(let i = 0; i < this.items.length; i++) {
        if(this.items[i] && this.items[i].img) {
          validImages.push(this.items[i])
        }
      }
      this.valid_images = [...validImages];
    });
    observer.observe(this.$refs.wrapper);
    //
    if ((this.$mq === 'large' && validImages.length > 4) || this.$mq !== 'large') {
      this.swiperInstance = new Swiper(this.$refs.swiper, {
        modules: [Pagination],
        allowTouchMove: true,
        // freeMode: true,
        slidesPerView: "auto",
        // slidesPerView: 4.5,
        spaceBetween: this.swiperSpace,
        centeredSlides: this.$mq !== 'large',
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      });
      if (this.$mq !== 'large') {
        this.swiperInstance.slideTo(0);
      }
    }
  },
  updated() {
    // PIAGGIO-8774: content visibility with zoom 400%
    this.windowWidth = window.visualViewport.width < 1010;
  }
}
</script>
